import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GridModule } from '@progress/kendo-angular-grid';
import { DailyLogModalPage } from './daily-log-modal';
import { DailyLogPageModule } from '../daily-log/daily-log.module';
import { DirectivesModule } from '../../../directives/directives.module';
import { PtKendoModule } from '../../../_foundation/kendo/modules/pt.kendo.module';

@NgModule({
  declarations: [
    DailyLogModalPage
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(DailyLogModalPage),
    GridModule,
    PtKendoModule,
    DailyLogPageModule
  ],
  exports: [
    DailyLogModalPage,
  ]
})
export class DailyLogModalPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/daily-log/daily-log-modal/daily-log-modal.module.ts